import { post } from "@/utils/request";
const baseUrl = process.env.config.RRDH_HOST;
export default {
  select: id => post(baseUrl + "/open/ompuser/select/" + id),
  update: query => post(baseUrl + "/open/ompuser/update", query),
  updateImg: query => post(baseUrl + "/open/ompuser/updateImg", query)
};
